export const numericBoolean = (arg?: boolean): number => (arg ? 1 : 0)
